import React from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import {
  Button,
  Card,
  Container,
  FormHelperText,
  Grid
} from '@material-ui/core';
import Header from './Header';
import MyRadioButton from './MyRadioButton';

function TrainingFrequency({ formData, setFormData, nextPage, prevPage }) {
  return (
    <React.Fragment>
      <Header title="How many days per week will you commit to training?" />
      <Container maxWidth="md" style={{ height: '500px', padding: '1rem' }}>
        <Card raised>
          <Formik
            initialValues={formData}
            validationSchema={yup.object({
              trainingFrequency: yup.string()
                .required('Please select an option')
            })}
            onSubmit={(values, actions) => {
              // console.log(JSON.parse(JSON.stringify(values)));
              setFormData(values)
              nextPage();
            }}
          >
            {formik => (
              <Form>
                <Container maxWidth="sm" style={{ padding: '1rem' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <MyRadioButton name="trainingFrequency" type="radio" value="3" label="3 Days" />
                    </Grid>
                    <Grid item xs={12}>
                      <MyRadioButton name="trainingFrequency" type="radio" value="5" label="5 Days" />
                    </Grid>
                    <Grid item xs={12}>
                      <MyRadioButton name="trainingFrequency" type="radio" value="5+" label="5+ Days" />
                    </Grid>
                    {!!formik.errors.trainingFrequency && (
                      <Grid item xs={12}>
                        <FormHelperText error>{formik.errors.trainingFrequency}</FormHelperText>
                      </Grid>
                    )}
                    <Grid item xs={4}>
                      <Button variant="contained" onClick={prevPage} fullWidth>Back</Button>
                    </Grid>
                    <Grid item xs={8}>
                      <Button variant="contained" color="primary" type="submit" fullWidth>Next</Button>
                    </Grid>
                  </Grid>
                  {/* <pre>{JSON.stringify(formik.values, null, 2)}</pre>
                  <pre>{JSON.stringify(formik.errors, null, 2)}</pre> */}
                </Container>
              </Form>
            )}
          </Formik>
        </Card>
      </Container>
    </React.Fragment>
  );
}

export default TrainingFrequency;